import Metaconfig from "@/views/systerm/dataConfig/metaconfig.vue"; //数据配置
import Classes from "@/views/systerm/dataConfig/classes.vue"; //主数据配置
import Lists from "@/views/systerm/dataConfig/list/lists.vue"; //列表配置
import ListInfo from "@/views/systerm/dataConfig/list/listInfo.vue"; //列表配置

// import Lists from "@/views/systerm/dataConfig/list/index.vue"; //列表配置
// import Lists from "@/views/systerm/dataConfig/list/list.vue"; //列表配置
// import listInfo from "@/views/systerm/dataConfig/list/info.vue"; //列表配置
// import listValue from "@/views/systerm/dataConfig/list/info.vue"; //列表配置
// import listWhereused from "@/views/systerm/dataConfig/list/info.vue"; //列表配置

//自动编号
import AutoNumbers from "@/views/systerm/dataConfig/autoNumber/autoNumbers.vue"; //列表配置
import AutoNumbersInfo from "@/views/systerm/dataConfig/autoNumber/autoNumbersInfo.vue";
import AutoNumbersWhereUsed from "@/views/systerm/dataConfig/autoNumber/autoNumbersWhereUsed.vue";
//属性编号
import CodeNumbers from "@/views/systerm/dataConfig/codeNumbers.vue"; //列表配置
//标准配置
import Criteria from "@/views/systerm/dataConfig/criteria/criteria.vue"; //标准配置

export const DataConfig = [
  {
    path: "/lists",
    component: Lists,
    name: "Lists",
    meta: {},
    children: [
      {
        path: "/listInfo",
        component: ListInfo,
        name: "ListInfo",
      },
    ],

    // children: [
    //   {
    //     name: "listInfo",
    //     path: "",
    //     redirect: "listInfo",
    //   },
    //   {
    //     path: "listInfo",
    //     component: listInfo,
    //   },
    //   {
    //     path: "listValue",
    //     component: listValue,
    //   },
    //   {
    //     path: "whereused",
    //     component: listWhereused,
    //   },
    // ],
  },
  {
    path: "/autoNumbers",
    name: "AutoNumbers",
    component: AutoNumbers,
    children: [
      {
        path: "AutoNumbersInfo",
        component: AutoNumbersInfo,
        meta: {},
      },
      {
        path: "AutoNumbersWhereUsed",
        component: AutoNumbersWhereUsed,
        meta: {},
      },
    ],
  },
  {
    path: "/codeNumbers",
    name: "CodeNumbers",
    component: CodeNumbers,
  },
  {
    path: "/criteria",
    name: "Criteria",
    component: Criteria,
  },
  {
    path: "/classes",
    component: Classes,
    name: "Classes",
  },
  {
    path: "/combinatorialDescription",
    component: () =>
      import("@/views/systerm/dataConfig/combinatorialDescription.vue"),
  },
  {
    path: "/QRCode",
    component: () =>
      import("@/views/systerm/dataConfig/QRCodeConfig/index.vue"),
  },
  {
    path: "/componentLibraryConfig",
    component: () =>
      import("@/views/systerm/dataConfig/componentLibraryConfig.vue"),
  },
  {
    path: "/settingAPI",
    component: () => import("@/views/systerm/dataConfig/settingAPI/index.vue"),
    children: [
      {
        // name: "privsInfo",
        path: "",
        redirect: "info",
      },
      {
        path: "info",
        component: () =>
          import("@/views/systerm/dataConfig/APIConfig/info.vue"),
      },
      {
        path: "history",
        component: () =>
          import("@/views/systerm/dataConfig/APIConfig/history.vue"),
      },
      {
        path: "whereused",
        component: () =>
          import("@/views/systerm/dataConfig/APIConfig/whereused.vue"),
      },
    ],
  },
];
